import api from "./api";

import { buildQueryParams } from "../utils/buildQueryParams";

class ContentsService {
  async get(filters = {}) {
    let params = "?";
    const { search, tag, limit, contentTypeId, sort, buttonVisibilityId } = filters;
    if (limit) params += "limit=" + limit + "&";
    if (search) params += "search=" + search + "&";
    if (tag) params += "tag=" + tag + "&";
    if (contentTypeId) params += "contentTypeId=" + contentTypeId + "&";
    if (sort) params += "sort=" + sort + "&";
    if (buttonVisibilityId) params += "buttonVisibilityId=" + buttonVisibilityId + "&";

    return api
      .get(`v1/api/contents${params}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Promise.reject(error);
      });
  }

  getAllContents(params) {
    const queryParams = buildQueryParams(params);
    return api.get(`v2/api/contents?${queryParams}`);
  }

  getContentsByType(type, params) {
    const queryParams = buildQueryParams(params);
    return api.get(`v2/api/contents/type/${type}?${queryParams}`);
  }

  getCategories(params) {
    const queryParams = buildQueryParams(params);
    return api.get(`v2/api/contents/categories?${queryParams}`);
  }

  getSubcategories(categoryId) {
    return api.get(`v2/api/contents/categories/${categoryId}/subcategories`);
  }

  getContentByLinkName(linkName) {
    return api.get(`v2/api/contents/${linkName}`);
  }

  getTags(params) {
    const queryParams = buildQueryParams(params);
    return api.get(`v2/api/contents/tags?${queryParams}`);
  }
}

export default new ContentsService();
